export const propertyInfo = {
  selectedInvestment: `Selected Investment`,
  totalAssetValue: `Total Asset Value $`,
}
